// ===== Auto-height cho trang cuộn =====
// Lib CDN scale #MS__wrapper bằng transform: scale(r) (transform-origin top-left).
// transform KHÔNG đổi kích thước layout -> body/html vẫn thấy chiều cao "natural" (chưa scale),
// gây dư khoảng trắng (r<1) hoặc cắt nội dung (r>1).
// -> Set chiều cao body = chiều cao thật của wrapper * tỉ lệ scale để vùng cuộn khớp phần nhìn thấy.
(function () {
  function fitHeight() {
    var wrap = document.getElementById("MS__wrapper");
    if (!wrap) return;
    // Lib lưu tỉ lệ scale trên body qua data-scale-ratio; fallback = rộng viewport / rộng design
    var ratio = parseFloat(document.body.getAttribute("data-scale-ratio"));
    if (!ratio || isNaN(ratio)) ratio = 1;
    // Đặt lại về auto trước khi đo để wrapper co lại theo nội dung mới (tránh dư chiều cao cũ)
    document.body.style.height = "auto";
    // scrollHeight = chiều cao natural (transform không ảnh hưởng)
    document.body.style.height = Math.ceil(wrap.scrollHeight * ratio) + "px";
  }
  // Cho phép section khác gọi lại khi nội dung đổi chiều cao (vd đổi tab)
  window.MS__fitHeight = fitHeight;

  // Chạy SAU khi lib scale xong (lib scale ở 'load' + 'resize')
  window.addEventListener("load", function () {
    setTimeout(fitHeight, 60);
    // Chạy lại sau khi ảnh/asset tải xong làm đổi chiều cao
    setTimeout(fitHeight, 400);
  });
  window.addEventListener("resize", function () {
    setTimeout(fitHeight, 120);
  });
})();
